var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-field',_vm._g(_vm._b({attrs:{"value":_vm.value},scopedSlots:_vm._u([{key:"button",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)},'van-field',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }